// @owners { team: patients-team }
import { COLORS, SPACING } from '@alto/design-library-tokens';
import { Body, Card, Icon, LgPadding, LgSpacing, Row } from '@alto/design-system';
import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { PageBackground, SingleColumnContentWrapper } from '~web/components/Page';

const Link = styled(NavLink)`
  color: ${COLORS.PALETTE.SECONDARY.DEFAULT};
  font-size: unset;
`;

export const DeliveryConfirmedPage = () => {
  return (
    <PageBackground>
      <SingleColumnContentWrapper>
        <Card title="Delivery confirmed!">
          <LgPadding topPadding={SPACING.STATIC.NONE}>
            <Row center>
              <Icon
                name="checkmark"
                type="disabled"
              />
            </Row>
            <LgSpacing />
            <Body>
              <Link to="/login">Login to your dashboard</Link> to edit this delivery.
            </Body>
          </LgPadding>
        </Card>
      </SingleColumnContentWrapper>
    </PageBackground>
  );
};
